import React from 'react';
import { NavLink } from 'react-router-dom';

const icons = {
  dashboard: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
    </svg>
  ),
  periods: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"/>
    </svg>
  ),
  transactions: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.82v-2.09c-2.04-.36-3.68-1.56-4.34-3.47l2.45-.92c.48 1.17 1.44 1.86 2.75 1.86 1.32 0 2.32-.78 2.32-1.82 0-2.25-6.62-1.07-6.62-5.55 0-2.03 1.62-3.6 3.86-3.95V2h2.82v1.91c2.04.36 3.39 1.63 3.93 3.34l-2.38.96c-.42-1.05-1.25-1.67-2.56-1.67-1.14 0-2.02.66-2.02 1.58 0 2.1 6.65 1.03 6.65 5.5 0 2.11-1.67 3.76-4.05 4.07z"/>
    </svg>
  ),
  templates: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l7.59-7.59L21 8l-9 9z"/>
    </svg>
  ),
  categories: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
  ),
  accounts: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 7h-4V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM9 5h6v2H9V5zm11 13H4v-2h5v-2h6v2h5v2z"/>
    </svg>
  ),
  statistics: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"/>
    </svg>
  ),
};

export default function Navigation() {
  // В нижней панели — только уникальные разделы (Траты/Счета/Шаблоны/Категории
  // уже есть кнопками-действиями на главной, чтобы не дублировать)
  const items = [
    { to: '/', label: 'Главная', icon: icons.dashboard },
    { to: '/periods', label: 'Периоды', icon: icons.periods },
    { to: '/statistics', label: 'Статистика', icon: icons.statistics },
  ];

  return (
    <nav className="bottom-nav">
      {items.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
